import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import AnimatedPage from "../components/AnimatedPage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Đảm bảo đã import CSS của datepicker

function HistoryCasino() {
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [history, setHistory] = useState([]); // Default là mảng rỗng để dễ map
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [isLoading, setLoading] = useState(true);
    const [endDate, setEndDate] = useState(new Date());
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Format ngày giờ hiển thị
    function formatDateDisplay(m) {
        const d = new Date(m);
        return d.getFullYear() + "-" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "-" + 
               ("0" + d.getDate()).slice(-2) + " " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    // Format ngày gửi lên API (YYYYMMDD)
    const formatApiDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
    };

    useEffect(() => {
        setLoading(true);
        const formattedDate = formatApiDate(new Date());
        
        axios.post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                if (res.data && res.data.data) {
                    setHistory(res.data.data);
                } else {
                    setHistory([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const selectHistory = (date) => {
        setLoading(true);
        const formattedDate = formatApiDate(date);
        
        axios.post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                if (res.data && res.data.data) {
                    setHistory(res.data.data);
                } else {
                    setHistory([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    const productId = (data) => {
        let a;
        switch (data?.toString()) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "99": a = "TF"; break;
            case "111": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            default: a = "Sảnh Game"; break;
        }
        return a;
    };

    // Icon Dropdown SVG
    const ChevronDown = () => (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="#aaa"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    );

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f5f7f9", overflow: "hidden" }}>
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f5f7f9; margin: 0; padding: 0; color: #333; }
                
                .h-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f9f9f9; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .h-app-main::-webkit-scrollbar { display: none; }
                .h-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                /* HEADER */
                .h-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .h-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .h-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}
                
                /* BỘ LỌC */
                .h-filters {
                    display: flex; gap: 10px; padding: 15px; background: #f9f9f9;
                }
                .h-filter-sel-wrap {
                    flex: 1; position: relative; display: flex; align-items: center;
                    background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;
                }
                .h-filter-icon {
                    position: absolute; right: 10px; pointer-events: none; display: flex;
                }
                
                /* TÙY CHỈNH DATEPICKER */
                .react-datepicker-wrapper { width: 100%; }
                .custom-datepicker {
                    width: 100%; border: none; outline: none; background: transparent;
                    padding: 10px 30px 10px 12px; font-size: 13px; color: #555;
                    cursor: pointer;
                }

                /* EMPTY STATE */
                .h-empty-state {
                    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
                    padding-top: 60px;
                }
                .h-empty-state svg { width: 120px; height: auto; margin-bottom: 20px; }
                .h-empty-state span { font-size: 14px; color: #555; font-weight: 500; }

                /* DANH SÁCH ITEM */
                .h-list { 
                    padding: 0 15px 20px 15px; 
                    background: #fff; 
                    margin: 0 15px; 
                    border-radius: 10px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                }
                .h-item {
                    background: transparent; 
                    padding: 15px 0; 
                    border-bottom: 1px solid #eee;
                    cursor: pointer;
                }
                .h-item:last-child {
                    border-bottom: none;
                }

                .h-item-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
                .h-item-title { font-size: 15px; font-weight: 600; color: #333; }
                .h-item-status { font-size: 12px; font-weight: 600; padding: 3px 8px; border-radius: 4px; color: #f39c12; background: rgba(243, 156, 18, 0.1); }
                
                .h-item-detail { font-size: 13px; color: #666; word-break: break-all; }
                .h-item-amount { font-size: 15px; font-weight: bold; }
                .h-item-date { font-size: 12px; color: #999; }
            `}} />

            <div className="h-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="h-header">
                        <div className="h-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="h-header-title">Lịch sử game</div>
                        <div style={{ width: '24px' }}></div> 
                    </div>

                    {/* ===== FILTERS ===== */}
                    <div className="h-filters">
                        <div className="h-filter-sel-wrap">
                            <DatePicker
                                maxDate={new Date()}
                                selected={endDate}
                                dateFormat="dd/MM/yyyy"
                                className="custom-datepicker"
                                onChange={(date) => {
                                    if(date) {
                                        setEndDate(date);
                                        selectHistory(date);
                                    }
                                }}
                            />
                            <div className="h-filter-icon"><ChevronDown /></div>
                        </div>
                    </div>

                    {/* ===== NỘI DUNG DANH SÁCH ===== */}
                    {isLoading ? (
                        <div style={{ textAlign: "center", padding: "50px", color: "#888", fontSize: "14px" }}>Đang tải dữ liệu...</div>
                    ) : (!history || history.length === 0) ? (
                        <div className="h-empty-state">
                            <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30" y="20" width="60" height="80" rx="8" fill="#e3f2fd" />
                                <rect x="40" y="40" width="40" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="55" width="30" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="70" width="20" height="6" rx="3" fill="#90caf9" />
                                <circle cx="70" cy="55" r="16" fill="#64b5f6" opacity="0.3" />
                                <path d="M85 35 L95 25 C97 23 100 23 102 25 L105 28 C107 30 107 33 105 35 L95 45 Z" fill="#25aae1" />
                                <path d="M85 35 L75 60 L80 62 L95 45 Z" fill="#4fc3f7" />
                                <path d="M75 60 L73 68 L78 65 Z" fill="#01579b" />
                                <path d="M75 65 Q 60 80 50 75" stroke="#25aae1" strokeWidth="2" fill="none" strokeLinecap="round" />
                            </svg>
                            <span>Không tìm thấy kết quả.</span>
                        </div>
                    ) : (
                        <div className="h-list">
                            {history.map((item, key) => {
                                const brandName = productId(item?.productType);
                                const isWin = Number(item?.winAmount) > 0;
                                const amountColor = isWin ? "#2ecc71" : "#e74c3c"; // Xanh nếu thắng, đỏ nếu thua
                                const prefix = isWin ? "+" : "";

                                return (
                                    <div 
                                        className="h-item" 
                                        key={key}
                                        onClick={() => {
                                            setLs(item);
                                            setShow(true);
                                        }}
                                    >
                                        <div className="h-item-row">
                                            <div className="h-item-title">{item?.gameName}</div>
                                            <div className="h-item-status">
                                                {brandName}
                                            </div>
                                        </div>
                                        
                                        <div className="h-item-row" style={{ marginTop: "10px", alignItems: "flex-end" }}>
                                            <div style={{ flex: 1, paddingRight: '10px', textAlign: 'left' }}>
                                                <div className="h-item-detail">
                                                    Cược: {Number(item?.betAmount).toLocaleString("vi-VN")}₫
                                                </div>
                                                <div className="h-item-date" style={{ marginTop: "4px", textAlign: "left", display: "block" }}>
                                                    {formatDateDisplay(item?.betTime)}
                                                </div>
                                            </div>
                                            <div className="h-item-amount" style={{ color: amountColor, textAlign: 'right' }}>
                                                Thắng: {prefix}{Number(item?.winAmount).toLocaleString('vi-VN')}₫
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </AnimatedPage>
            </div>
            
        </div>
    );
}

export default HistoryCasino;